import { LogoFamilysearch } from '@fs/zion-icon'
import { Button, useOverlay } from '@fs/zion-ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { deepCopy } from '../../../../util/Utils'
import CreateTreePersonDialog from './CreateTreePersonDialog'
import ModifyCtrDialog from './ModifyCtrDialog'

export default function CreateTreePersonButton({ templePlatform }) {
  const { t } = useTranslation()
  const createTreePersonOverlay = useOverlay()
  const modifyCtrOverlay = useOverlay()
  const [modifiedPersons, setModifiedPersons] = useState([])
  const templePlatformCopy = deepCopy(templePlatform)

  return (
    <>
      <Button emphasis="medium" Icon={LogoFamilysearch} onClick={createTreePersonOverlay.handleClick}>
        {t('ctr.summary.createTreePerson.buttonLabel', 'Create Tree Person')}
      </Button>
      <CreateTreePersonDialog
        templePlatform={templePlatformCopy}
        openModifyCtrDialog={modifyCtrOverlay.open}
        setModifiedPersons={setModifiedPersons}
        {...createTreePersonOverlay}
      />
      <ModifyCtrDialog templePlatform={templePlatformCopy} modifiedPersons={modifiedPersons} {...modifyCtrOverlay} />
    </>
  )
}
